import { render } from "./TemplateCardV2.vue?vue&type=template&id=fda467c6&scoped=true"
import script from "./TemplateCardV2.vue?vue&type=script&lang=js"
export * from "./TemplateCardV2.vue?vue&type=script&lang=js"

import "./TemplateCardV2.vue?vue&type=style&index=0&id=fda467c6&lang=scss&scoped=true"
import "./TemplateCardV2.vue?vue&type=style&index=1&id=fda467c6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fda467c6"]])

export default __exports__